import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./SignIn.module.sass";
import { use100vh } from "react-div-100vh";
import { Link, useNavigate } from "react-router-dom";
import TextInput from "../../components/TextInput";
import PhoneInput from "../../components/PhoneInput";
import Image from "../../components/Image";
import Dropdown from "../../components/Dropdown";
import DualButton from "../../components/DualButton";
import { useAuth } from "../../contexts/AuthContext";
import { formatDateForInput, isMinor } from "../../services/date.service";
import { showSuccess, showError } from "../../services/toast.service";
import { updateStudent, getStudentForCurrentUser } from "../../services/student.service";
import { pb } from "../../services/pocketbase";
import Switch from "../../components/Switch";
import ModalConditionGeneral from "../../components/ModalConditionGeneral";
import ModalPolitiqueConfidentialite from "../../components/ModalPolitiqueConfidentialite";
import ModalReglement from "../../components/ModalReglement";

const SEX_OPTIONS = [
  { value: 'M', title: 'Masculin' },
  { value: 'F', title: 'Feminin' }
];

const settings = [
  {
    id: 0,
    title: "Conditions générales",
  },
  {
    id: 1,
    title: "Politique de confidentialité",
  },
  {
    id: 2,
    title: "Rêglement intérieur",
  },
];

const REGIME_SOCIAL_OPTIONS = [
  { value: '1', title: '1 - MSA' },
  { value: '2', title: '2 - URSSAF' }
];

const NATIONALITY_OPTIONS = [
  { value: '1', title: 'Française' },
  { value: '2', title: 'Union Européenne' },
  { value: '3', title: 'Etranger hors Union Européenne' },
];

const SITUATION_OPTIONS = [
  { value: '1', title: '1 - Scolaire' },
  { value: '2', title: '2 - Prépa apprentissage' },
  { value: '3', title: '3 - Etudiant' },
  { value: '4', title: '4 - Contrat d\'apprentissage' },
  { value: '5', title: '5 - Contrat de professionnalisation' },
  { value: '6', title: '6 - Contrat aidé' },
  { value: '7', title: '7 - En formation au CFA avant signature d\'un contrat d\'apprentissage (L6222-12-1 du code du travail)' },
  { value: '8', title: '8 - En formation, au CFA, sans contrat, suite à rupture (5° de L6231-2 du code du travail)' },
  { value: '9', title: '9 - Stagiaire de la formation professionnelle' },
  { value: '10', title: '10 - Salarié' },
  { value: '11', title: '11 - Personne à la recherche d\'un emploi (inscrite ou non au Pôle Emploi)' },
  { value: '12', title: '12 - Inactif' }
];

const CLASS_OPTIONS = [
  { value: '1', title: "1 - L'apprenti a suivi la dernière année du cycle de formation et a obtenu le diplôme" },
  { value: '11', title: "11 - l'apprenti a suivi la 1ère année du cycle et l'a validé (examens réusss mais année non diplômantes)" },
  { value: '12', title: "12 - L'apprenti a suivi laa 1ère année du cycle mais ne l'a pas validée (échec aux examens, interruption ou abandon de formation)" },
  { value: '21', title: "21 - l'apprenti a suiv la 2è année de cyle et l'a validée (examens réusss mais année non diplômantes)" },
  { value: '22', title: "22 - L'apprenti a suivi la 2è année du cycle mais ne l'a pas validée (échec aux examens, interruption ou abandon de formation)" },
  { value: '31', title: "31 - L'apprenti a suivi la 3ème année du cycle et l'a validée (examens réusss mais année non diplômantes, cycle adapté)" },
  { value: '32', title: "32 - L'apprenti a suivi la 3ème année du cycle mais ne l'a pas validée (échec aux examens, interruption ou abandon de formation)" },
  { value: '40', title: "40 - l'apprenti a achevé le 1er cycle de l'enseignement secondaire (collège)" },
  { value: '41', title: "41 - l'apprenti a interrompu ses études en classe de 3è" },
  { value: '42', title: "42 - l'apprenti a abandonné ses études en classe de 4è" }
];

const DIPLOMA_OPTIONS = [
  { value: '13', title: "13 - Aucun diplôme ni titre professionnel" },
  { value: '25', title: "25 - Diplôme national du brevet (DNB)" },
  { value: '26', title: "26 - Certificat de formation générale" },
  { value: '38', title: "38 - Autre diplôme ou titre de niveau CAP/BEP" },
  { value: '35', title: "35 - Mention complémentaire" },
  { value: '34', title: "34 - BEP" },
  { value: '33', title: "33 - CAP" },
  { value: '49', title: "49 - Autre diplôme ou titre de niveau bac" },
  { value: '43', title: "43 - Baccalauréat Technologique" },
  { value: '42', title: "42 - Baccalauréat Général" },
  { value: '41', title: "41 - Baccalauréat Professionnel" },
  { value: '58', title: "58 - Autre diplôme ou titre de niveau bac+2" },
  { value: '55', title: "55 - Diplôme Universitaire de technologie" },
  { value: '54', title: "54 - Brevet de Techniciens supérieurs" },
  { value: '69', title: "69 - Autre diplôme ou titre de niveau bac +3 ou 4" },
  { value: '64', title: "64 - Bachelor Universitaire  ed technologie BUT" },
  { value: '63', title: "63 - Licence générale" },
  { value: '62', title: "62 - Licence professionnelle" },
  { value: '61', title: "61 - 1ère année de Master" },
  { value: '79', title: "79 - Autre diplôme ou titre de niveau bac +5 ou plus" },
  { value: '74', title: "74 - Diplôme d'ingénieur, diplôme de commerce" },
  { value: '73', title: "73 - Master indifférencié" },
  { value: '72', title: "72 - Master recherche/DEA" },
  { value: '71', title: "71 - Master professionnel/DESS" },
  { value: '80', title: "80 - Doctorat" }
];

const HIGHEST_DIPLOMA_OPTIONS = [
  { value: '13', title: "13 - Aucun diplôme ni titre professionnel" },
  { value: '25', title: "25 - Diplôme national du brevet (DNB)" },
  { value: '26', title: "26 - Certificat de formation générale" },
  { value: '38', title: "38 - Autre diplôme ou titre de niveau CAP/BEP" },
  { value: '35', title: "35 - Mention complémentaire" },
  { value: '34', title: "34 - BEP" },
  { value: '33', title: "33 - CAP" },
  { value: '49', title: "49 - Autre diplôme ou titre de niveau bac" },
  { value: '43', title: "43 - Baccalauréat Technologique" },
  { value: '42', title: "42 - Baccalauréat Général" },
  { value: '41', title: "41 - Baccalauréat Professionnel" },
  { value: '58', title: "58 - Autre diplôme ou titre de niveau bac+2" },
  { value: '55', title: "55 - Diplôme Universitaire de technologie" },
  { value: '54', title: "54 - Brevet de Techniciens supérieurs" },
  { value: '69', title: "69 - Autre diplôme ou titre de niveau bac +3 ou 4" },
  { value: '64', title: "64 - Bachelor Universitaire  ed technologie BUT" },
  { value: '63', title: "63 - Licence générale" },
  { value: '62', title: "62 - Licence professionnelle" },
  { value: '61', title: "61 - 1ère année de Master" },
  { value: '79', title: "79 - Autre diplôme ou titre de niveau bac +5 ou plus" },
  { value: '74', title: "74 - Diplôme d'ingénieur, diplôme de commerce" },
  { value: '73', title: "73 - Master indifférencié" },
  { value: '72', title: "72 - Master recherche/DEA" },
  { value: '71', title: "71 - Master professionnel/DESS" },
  { value: '80', title: "80 - Doctorat" }
];

const CompleteAccount = () => {
  const heightWindow = use100vh();
  const navigate = useNavigate();
  const { login, currentUser } = useAuth();

  // États pour gérer les données de l'étudiant
  const [student, setStudent] = useState({});
  const [initialStudent, setInitialStudent] = useState({});
  const [loading, setLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [selectedSex, setSelectedSex] = useState('');
  const [selectedNationality, setSelectedNationality] = useState('');
  const [acceptConditions, setAcceptConditions] = useState(false);
  const [acceptUseConditions, setAcceptUseConditions] = useState(false);
  const [acceptRules, setAcceptRules] = useState(false);

  // États pour les champs d'études
  const [selectedSituationBeforeContract, setSelectedSituationBeforeContract] = useState('');
  const [selectedLastClass, setSelectedLastClass] = useState('');
  const [selectedLastPreparedDiploma, setSelectedLastPreparedDiploma] = useState('');
  const [selectedHighestDiplomaObtained, setSelectedHighestDiplomaObtained] = useState('');
  const [businessOwnerProject, setBusinessOwnerProject] = useState('Non');


  // États pour gérer l'affichage des modales
  const [visibleCondition, setVisibleCondition] = useState(false);
  const [visibleUseCondition, setVisibleUseCondition] = useState(false);
  const [visibleReglement, setVisibleReglement] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isRQTH, setIsRQTH] = useState(Boolean(initialStudent?.is_rqth));
  const [isBOE, setIsBOE] = useState(Boolean(initialStudent?.is_boe));
  const [isDisabled, setIsDisabled] = useState(Boolean(initialStudent?.is_disabled));
  const [isHighLevelSport, setIsHighLevelSport] = useState(Boolean(initialStudent?.high_level_sport));
  const [selectedSocialRegime, setSelectedSocialRegime] = useState('');
  const [consentToShareWithCompanies, setConsentToShareWithCompanies] = useState(Boolean(initialStudent?.consent_to_share_with_companies));

  // Détecter si l'affichage est en mode mobile
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Vérifier au chargement
    checkIfMobile();

    // Ajouter un listener pour détecter les changements de taille d'écran
    window.addEventListener('resize', checkIfMobile);

    // Nettoyer le listener lors du démontage du composant
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);


  // Charger les données de l'étudiant depuis PocketBase
  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        setLoading(true);
        // Vérifier si l'utilisateur est connecté
        if (!pb.authStore.isValid) {
          console.error('Utilisateur non connecté');
          navigate('/signin');
          return;
        }

        // Utiliser la fonction du service pour récupérer ou initialiser l'étudiant
        const studentData = await getStudentForCurrentUser();

        // Mettre à jour les états
        setStudent(studentData);
        setInitialStudent(studentData);
        
        // Trouver l'option correspondant à la valeur en BDD (M ou F)
        const sexOption = SEX_OPTIONS.find(option => option.value === studentData.sex);
        setSelectedSex(sexOption || '');
        
        // Trouver l'option correspondant à la valeur en BDD (1, 2 ou 3)
        const nationalityOption = NATIONALITY_OPTIONS.find(option => option.value === studentData.nationality);
        setSelectedNationality(nationalityOption || '');

        // Trouver l'option correspondant à la valeur en BDD pour le régime social
        const socialRegimeOption = REGIME_SOCIAL_OPTIONS.find(option => option.value === studentData.social_diet);
        setSelectedSocialRegime(socialRegimeOption || '');

        // Initialiser les champs d'études
        const situationOption = SITUATION_OPTIONS.find(option => option.value === studentData.situation_before_contract);
        setSelectedSituationBeforeContract(situationOption || '');
        
        const classOption = CLASS_OPTIONS.find(option => option.value === studentData.last_class);
        setSelectedLastClass(classOption || '');
        
        const diplomaOption = DIPLOMA_OPTIONS.find(option => option.value === studentData.last_prepared_diploma);
        setSelectedLastPreparedDiploma(diplomaOption || '');
        
        const highestDiplomaOption = HIGHEST_DIPLOMA_OPTIONS.find(option => option.value === studentData.highest_diploma_obtained);
        setSelectedHighestDiplomaObtained(highestDiplomaOption || '');
        
        setBusinessOwnerProject(studentData.is_business_owner ? 'Oui' : 'Non');

        setLoading(false);

      } catch (error) {
        console.error('Erreur lors de la récupération des données:', error);
        setLoading(false);
        showError('Erreur lors de la récupération des données');
      }
    };

    fetchStudentData();
  }, [navigate]);


  const handleChange = (id) => {
    if (id === 0) {
      setAcceptConditions(!acceptConditions);
    } else if (id === 1) {
      setAcceptUseConditions(!acceptUseConditions);
    } else if (id === 2) {
      setAcceptRules(!acceptRules);
    }
    // Valider le formulaire après la mise à jour des conditions
    setTimeout(() => validateForm(), 0);
  };


  // Gestionnaire de changement pour les champs de texte
  const handleStudentChange = (e) => {
    const { name, value } = e.target;

    // Mapper les noms de champs du formulaire vers les propriétés de l'objet student
    const fieldMapping = {
      'lastName': 'last_name',
      'firstName': 'first_name',
      'nationality': 'nationality',
      'sex': 'sex',
      'phone': 'phone',
      'email': 'email',
      'birthDate': 'birth_date',
      'birthPlace': 'birth_place',
      'birthDepartment': 'birth_department',
      'address': 'address',
      'addressComplement': 'address_complement',
      'zipCode': 'zip_code',
      'city': 'city',
      'country': 'country',
      'legal_guardian_last_name': 'legal_guardian_last_name',
      'legal_guardian_first_name': 'legal_guardian_first_name',
      'legal_guardian_phone': 'legal_guardian_phone',
      'legal_guardian_email': 'legal_guardian_email',
      'legal_guardian_address': 'legal_guardian_address',
      'legal_guardian_address_complement': 'legal_guardian_address_complement',
      'legal_guardian_department': 'legal_guardian_department',
      'legal_guardian_zip_code': 'legal_guardian_zip_code',
      'legal_guardian_city': 'legal_guardian_city',
      'legal_guardian_country': 'legal_guardian_country',
      'nir_code': 'nir_code',
      'social_diet': 'social_diet',
      'isHighLevelSport': 'is_high_level_sport',
      'isRQTH': 'is_rqth',
      'isBOE': 'is_boe',
      'isDisabled': 'is_disabled'
    };

    const fieldName = fieldMapping[name] || name;

    setStudent(prev => {
      const updatedStudent = {
        ...prev,
        [fieldName]: value
      };



      return updatedStudent;
    });
  };

  // Gestionnaire de changement pour les dropdowns
  const handleDropdownChange = (name, value) => {
    if (name === 'sex') {
      setSelectedSex(value);
      setStudent(prev => {
        const updatedStudent = {
          ...prev,
          sex: value.value // Stocker la valeur (M ou F) dans l'objet student
        };
        setTimeout(() => validateForm(), 0);
        return updatedStudent;
      });
    } else if (name === 'nationality') {
      setSelectedNationality(value);
      setStudent(prev => {
        const updatedStudent = {
          ...prev,
          nationality: value.value // Stocker la valeur (1, 2 ou 3) dans l'objet student
        };
        setTimeout(() => validateForm(), 0);
        return updatedStudent;
      });
    } else if (name === 'social_diet') {
      setSelectedSocialRegime(value);
      setStudent(prev => {
        const updatedStudent = {
          ...prev,
          social_diet: value.value
        };
        setTimeout(() => validateForm(), 0);
        return updatedStudent;
      });
    } else if (name === 'situation_before_contract') {
      setSelectedSituationBeforeContract(value);
      setStudent(prev => {
        const updatedStudent = {
          ...prev,
          situation_before_contract: value.value
        };
        setTimeout(() => validateForm(), 0);
        return updatedStudent;
      });
    } else if (name === 'last_class') {
      setSelectedLastClass(value);
      setStudent(prev => {
        const updatedStudent = {
          ...prev,
          last_class: value.value
        };
        setTimeout(() => validateForm(), 0);
        return updatedStudent;
      });
    } else if (name === 'last_prepared_diploma') {
      setSelectedLastPreparedDiploma(value);
      setStudent(prev => {
        const updatedStudent = {
          ...prev,
          last_prepared_diploma: value.value
        };
        setTimeout(() => validateForm(), 0);
        return updatedStudent;
      });
    } else if (name === 'highest_diploma_obtained') {
      setSelectedHighestDiplomaObtained(value);
      setStudent(prev => {
        const updatedStudent = {
          ...prev,
          highest_diploma_obtained: value.value
        };
        setTimeout(() => validateForm(), 0);
        return updatedStudent;
      });
    }
  };

  // Fonction pour valider le formulaire
  const validateForm = () => {
    const missingFields = [];

    // Validation des champs obligatoires
    const requiredFields = [
      { field: 'last_name', label: 'Nom' },
      { field: 'first_name', label: 'Prénom' },
      { field: 'sex', label: 'Sexe' },
      { field: 'nationality', label: 'Nationalité' },
      { field: 'phone', label: 'Numéro de téléphone' },
      { field: 'email', label: 'Email' },
      { field: 'birth_date', label: 'Date de naissance' },
      { field: 'address', label: 'Adresse' },
      { field: 'zip_code', label: 'Code postal' },
      { field: 'city', label: 'Ville' },
      { field: 'country', label: 'Pays' },
      { field: 'social_diet', label: 'Régime social' },
      { field: 'situation_before_contract', label: 'Situation avant contrat' },
      { field: 'last_class', label: 'Dernière classe' },
      { field: 'last_prepared_diploma', label: 'Dernier diplôme préparé' },
      { field: 'highest_diploma_obtained', label: 'Diplôme ou titre le plus élevé obtenu' }
    ];

    // Vérifier les champs obligatoires
    requiredFields.forEach(({ field, label }) => {
      if (!student[field] || student[field] === '') {
        missingFields.push(label);
      }
    });

    // Vérifier les champs spécifiques pour les mineurs
    if (isMinor(student.birth_date)) {
      const requiredGuardianFields = [
        { field: 'legal_guardian_last_name', label: 'Nom du responsable légal' },
        { field: 'legal_guardian_first_name', label: 'Prénom du responsable légal' },
        { field: 'legal_guardian_phone', label: 'Téléphone du responsable légal' },
        { field: 'legal_guardian_address', label: 'Adresse du responsable légal' },
        { field: 'legal_guardian_zip_code', label: 'Code postal du responsable légal' },
        { field: 'legal_guardian_city', label: 'Ville du responsable légal' },
        { field: 'legal_guardian_country', label: 'Pays du responsable légal' }
      ];

      requiredGuardianFields.forEach(({ field, label }) => {
        if (!student[field] || student[field] === '') {
          missingFields.push(label);
        }
      });
    }

    // Vérifier les conditions générales
    if (!acceptConditions || !acceptUseConditions || !acceptRules) {
      missingFields.push('Acceptation des conditions générales, conditions d\'utilisation et règlement intérieur');
    }

    return missingFields;
  };

  // Gestionnaire de changement pour les DualButtons
  const handleHealthDualButtonChange = (name) => (value) => {
    const boolValue = value === 'Oui';
    switch (name) {
      case 'isRQTH':
        setIsRQTH(boolValue);
        break;
      case 'isHighLevelSport':
        setIsHighLevelSport(boolValue);
        break;
      case 'isBOE':
        setIsBOE(boolValue);
        break;
      case 'isDisabled':
        setIsDisabled(boolValue);
        break;
      case 'consentToShareWithCompanies':
        setConsentToShareWithCompanies(boolValue);
        break;
      default:
        break;
    }
  };

  // Gestionnaire de changement pour les switches (conditions)
  const handleSwitchChange = (name, checked) => {
    switch (name) {
      case 'consentToShareWithCompanies':
        setConsentToShareWithCompanies(checked);
        break;
      default:
        break;
    }
  };

  // Gestionnaire pour le DualButton du projet d'entreprise
  const handleBusinessOwnerProjectChange = (value) => {
    setBusinessOwnerProject(value);
    setStudent(prev => {
      const updatedStudent = {
        ...prev,
        is_business_owner: value === 'Oui'
      };
      setTimeout(() => validateForm(), 0);
      return updatedStudent;
    });
  };

  // Sauvegarder les modifications
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Valider le formulaire avant de soumettre
    const missingFields = validateForm();
    if (missingFields.length > 0) {
      showError(`Veuillez remplir tous les champs obligatoires: ${missingFields.join(', ')}`);
      return;
    }

    setIsSaving(true);

    try {
      // Préparer les données pour la mise à jour ou la création
      const studentData = {
        first_name: student.first_name,
        last_name: student.last_name,
        sex: student.sex, // Utiliser la valeur déjà stockée dans student.sex (M ou F)
        nationality: student.nationality,
        phone: student.phone,
        email: student.email,
        birth_date: student.birth_date,
        birth_place: student.birth_place,
        birth_department: student.birth_department,
        address: student.address,
        address_complement: student.address_complement,
        zip_code: student.zip_code,
        city: student.city,
        country: student.country,
        user_ref: pb.authStore.model.id, // Référence à l'utilisateur connecté
        accept_conditions: acceptConditions,
        accept_rules: acceptRules,
        nir_code: student.nir_code,
        social_diet: selectedSocialRegime ? selectedSocialRegime.value : '',
        is_rqth: isRQTH,
        is_boe: isBOE,
        is_disabled: isDisabled,
        high_level_sport: isHighLevelSport,
        consent_to_share_with_companies: consentToShareWithCompanies,
        situation_before_contract: student.situation_before_contract,
        last_class: student.last_class,
        last_prepared_diploma: student.last_prepared_diploma,
        highest_diploma_obtained: student.highest_diploma_obtained,
        highest_diploma_title: student.highest_diploma_title,
        is_business_owner: businessOwnerProject === 'Oui',
        profil_status: 'Complet'
      };

      // Ajouter les informations du responsable légal si l'étudiant est mineur
      if (isMinor(student.birth_date)) {
        studentData.legal_guardian_last_name = student.legal_guardian_last_name;
        studentData.legal_guardian_first_name = student.legal_guardian_first_name;
        studentData.legal_guardian_phone = student.legal_guardian_phone;
        studentData.legal_guardian_email = student.legal_guardian_email;
        studentData.legal_guardian_address = student.legal_guardian_address;
        studentData.legal_guardian_address_complement = student.legal_guardian_address_complement;
        studentData.legal_guardian_department = student.legal_guardian_department;
        studentData.legal_guardian_zip_code = student.legal_guardian_zip_code;
        studentData.legal_guardian_city = student.legal_guardian_city;
        studentData.legal_guardian_country = student.legal_guardian_country;
      }

      let result;

      if (student.id) {
        // Si l'étudiant existe déjà, mettre à jour ses informations
        result = await updateStudent(student.id, studentData);
        showSuccess('Informations mises à jour avec succès');
      }

      // Mettre à jour l'état first_connexion et les différentes conditions de l'utilisateur
      try {
        await pb.collection('users').update(pb.authStore.model.id, {
          first_connexion: false,
          reglementation: true,
          conditionGeneral: true,
          conditionUtilisation: true
        });
      } catch (userUpdateError) {
        console.error('Erreur lors de la mise à jour des informations utilisateur:', userUpdateError);
      }

      // Mettre à jour l'état local avec les données mises à jour
      setStudent(result);
      setInitialStudent(result);

      // Rediriger vers la page d'accueil après la sauvegarde réussie
      navigate('/student/account');

    } catch (error) {
      console.error('Erreur lors de la sauvegarde des informations de l\'étudiant:', error);
      showError('Erreur lors de la sauvegarde: ' + (error.message || 'Veuillez vérifier vos informations'));
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className={styles.row}>
      <div
        className={styles.col}
        style={{
          backgroundImage: `url('/images/content/loginbg.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: heightWindow,
          flex: 1
        }}
      />
      <div className={styles.col} style={{ minHeight: heightWindow, flex: 1.5, overflow: 'auto', maxHeight: '100vh' }}>
        <div className={styles.head}>
          <div className={styles.logo}>
            <Image
              className={styles.pic}
              src="/images/logo.png"
              srcDark="/images/logo.png"
              alt="Core"
            />
          </div>
          <div className={cn("h2", styles.title)}>Compléter votre compte</div>
        </div>

        {loading ? (
          <div className={styles.wrapper}>
            <div>Chargement des informations...</div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className={styles.body}>
              <div className={styles.section}>
                <h3 className={styles.sectionTitle}>
                  Informations personnelles
                </h3>
                <div className={styles.formGrid}>
                  <TextInput
                    className={styles.field}
                    label="Nom"
                    name="lastName"
                    id="lastName"
                    type="text"
                    placeholder="Nom de famille"
                    value={student.last_name || ''}
                    onChange={handleStudentChange}
                    autoComplete="family-name"
                    readOnly={false}
                    required

                  />
                  <TextInput
                    className={styles.field}
                    label="Prénom"
                    name="firstName"
                    id="firstName"
                    type="text"
                    placeholder="Prénom"
                    value={student.first_name || ''}
                    onChange={handleStudentChange}
                    autoComplete="given-name"
                    required

                  />
                </div>

                <div className={styles.formGrid}>
                  <div className={styles.field}>
                    <Dropdown
                      className={styles.dropdown}
                      label="Sexe"
                      name="sex"
                      type="text"
                      tooltip="Sexe de l'étudiant"
                      required
                      options={SEX_OPTIONS}
                      setValue={(value) => handleDropdownChange('sex', value)}
                      value={selectedSex}
                    />
                  </div>

                  <div className={styles.field}>
                    <Dropdown
                      className={styles.dropdown}
                      label="Nationalité"
                      name="nationality"
                      type="text"
                      tooltip="Nationalité de l'étudiant"
                      required
                      options={NATIONALITY_OPTIONS}
                      setValue={(value) => handleDropdownChange('nationality', value)}
                      value={selectedNationality}
                    />
                  </div>


                  <TextInput
                    className={styles.field}
                    label="Date de naissance"
                    name="birthDate"
                    id="birthDate"
                    type="date"
                    value={formatDateForInput(student.birth_date)}
                    onChange={handleStudentChange}
                    autoComplete="bday"
                    required
                  />

                  <TextInput
                    className={styles.field}
                    label="Commune de naissance"
                    name="birthPlace"
                    id="birthPlace"
                    type="text"
                    value={student.birth_place || ''}
                    onChange={handleStudentChange}
                    autoComplete="off"
                    required
                  />

                  <TextInput
                    className={styles.field}
                    label="Département de naissance"
                    name="birthDepartment"
                    id="birthDepartment"
                    type="number"
                    value={student.birth_department || ''}
                    onChange={handleStudentChange}
                    autoComplete="off"
                    required
                  />

                </div>
              </div>

              <div className={styles.section}>
                <h3 className={styles.sectionTitle}>
                  Contact
                </h3>
                <PhoneInput
                  className={styles.field}
                  label="Numéro de téléphone"
                  name="phone"
                  id="phone"
                  placeholder="Numéro de téléphone"
                  value={student.phone || ''}
                  onChange={handleStudentChange}
                  autoComplete="tel"
                  required
                />

                <TextInput
                  className={styles.field}
                  label="Email"
                  name="email"
                  type="email"
                  placeholder="email@example.com"
                  value={student.email || ''}
                  onChange={handleStudentChange}
                  required
                />
              </div>

              {isMinor(student.birth_date) && (
                <div className={styles.section}>
                  <h3 className={styles.sectionTitle}>
                    Informations du responsable légal
                  </h3>
                  <div className={styles.formGrid}>
                    <TextInput
                      className={styles.field}
                      label="Nom"
                      name="legal_guardian_last_name"
                      id="legal_guardian_last_name"
                      type="text"
                      value={student.legal_guardian_last_name || ''}
                      onChange={handleStudentChange}
                      autoComplete="family-name"
                      required
                    />

                    <TextInput
                      className={styles.field}
                      label="Prénom"
                      name="legal_guardian_first_name"
                      id="legal_guardian_first_name"
                      type="text"
                      value={student.legal_guardian_first_name || ''}
                      onChange={handleStudentChange}
                      autoComplete="given-name"
                      required
                    />
                  </div>
                  <div className={styles.formGrid}>
                    <PhoneInput
                      className={styles.field}
                      label="Numéro de téléphone"
                      name="legal_guardian_phone"
                      id="legal_guardian_phone"
                      placeholder="Numéro de téléphone"
                      value={student.legal_guardian_phone || ''}
                      onChange={handleStudentChange}
                      autoComplete="tel"
                      required
                    />

                    <TextInput
                      className={styles.field}
                      label="Email"
                      name="legal_guardian_email"
                      id="legal_guardian_email"
                      type="email"
                      placeholder="email@example.com"
                      value={student.legal_guardian_email || ''}
                      onChange={handleStudentChange}
                      required
                    />
                  </div>
                </div>
              )}

              <div className={styles.section}>
                <h3 className={styles.sectionTitle}>
                  Adresse
                </h3>

                <div className={styles.formGrid}>
                  <TextInput
                    className={styles.field}
                    label="Adresse"
                    name="address"
                    id="address"
                    type="text"
                    placeholder="Adresse"
                    value={student.address || ''}
                    onChange={handleStudentChange}
                    autoComplete="off"
                    required
                  />

                  <TextInput
                    className={styles.field}
                    label="Complément d'adresse"
                    name="addressComplement"
                    id="addressComplement"
                    type="text"
                    placeholder="Complément d'adresse"
                    value={student.address_complement || ''}
                    onChange={handleStudentChange}
                    autoComplete="off"
                  />

                  <TextInput
                    className={styles.field}
                    label="Code postal"
                    name="zipCode"
                    id="zipCode"
                    type="text"
                    placeholder="Code postal"
                    value={student.zip_code || ''}
                    onChange={handleStudentChange}
                    autoComplete="off"
                    required
                  />

                  <TextInput
                    className={styles.field}
                    label="Ville"
                    name="city"
                    id="city"
                    type="text"
                    placeholder="Ville"
                    value={student.city || ''}
                    onChange={handleStudentChange}
                    autoComplete="off"
                    required
                  />
                  <TextInput
                    className={styles.field}
                    label="Pays"
                    name="country"
                    id="country"
                    type="text"
                    placeholder="Pays"
                    value={student.country || ''}
                    onChange={handleStudentChange}
                    autoComplete="off"
                    required
                  />

                </div>
              </div>

              {isMinor(student.birth_date) && (
                <div className={styles.section}>
                  <h3 className={styles.sectionTitle}>
                    Adresse parent légal
                  </h3>


                  <div className={styles.formGrid}>
                    <TextInput
                      className={styles.field}
                      label="Adresse"
                      name="legal_guardian_address"
                      id="legal_guardian_address"
                      type="text"
                      placeholder="Adresse"
                      value={student.legal_guardian_address || ''}
                      onChange={handleStudentChange}
                      autoComplete="off"
                      required
                    />

                    <TextInput
                      className={styles.field}
                      label="Complément d'adresse"
                      name="legal_guardian_address_complement"
                      id="legal_guardian_address_complement"
                      type="text"
                      placeholder="Complément d'adresse"
                      value={student.legal_guardian_address_complement || ''}
                      onChange={handleStudentChange}
                      autoComplete="off"
                    />

                    <TextInput
                      className={styles.field}
                      label="Code postal"
                      name="legal_guardian_zip_code"
                      id="legal_guardian_zip_code"
                      type="text"
                      placeholder="Code postal"
                      value={student.legal_guardian_zip_code || ''}
                      onChange={handleStudentChange}
                      autoComplete="off"
                      required
                    />

                    <TextInput
                      className={styles.field}
                      label="Ville"
                      name="legal_guardian_city"
                      id="legal_guardian_city"
                      type="text"
                      placeholder="Ville"
                      value={student.legal_guardian_city || ''}
                      onChange={handleStudentChange}
                      autoComplete="off"
                      required
                    />

                    <TextInput
                      className={styles.field}
                      label="Département actuel"
                      name="legal_guardian_department"
                      id="legal_guardian_department"
                      type="text"
                      value={student.legal_guardian_department || ''}
                      onChange={handleStudentChange}
                      autoComplete="off"
                      required
                    />

                    <TextInput
                      className={styles.field}
                      label="Pays"
                      name="legal_guardian_country"
                      id="legal_guardian_country"
                      type="text"
                      placeholder="Pays"
                      value={student.legal_guardian_country || ''}
                      onChange={handleStudentChange}
                      autoComplete="off"
                      required
                    />
                  </div>
                </div>
              )}

              <div className={styles.divider} />

              <h3 className={styles.sectionTitle}>
                Informations santé
              </h3>
              <div className={styles.formGrid}>
                <TextInput
                  className={styles.field}
                  label="Code de sécurité sociale"
                  name="nir_code"
                  type="number"
                  placeholder="Code de sécurité sociale"
                  value={student.nir_code || ''}
                  onChange={handleStudentChange}
                  required
                />

                <div className={styles.field}>
                  <Dropdown
                    className={styles.dropdown}
                    label="Régime social"
                    name="social_diet"
                    type="text"
                    required
                    options={REGIME_SOCIAL_OPTIONS}
                    setValue={(value) => handleDropdownChange('social_diet', value)}
                    value={selectedSocialRegime}
                  />
                </div>


                <div className={styles.field}>
                  <DualButton
                    label="Inscrit sur la liste des sportifs de haut niveau"
                    option1="Oui"
                    option2="Non"
                    value={isHighLevelSport ? 'Oui' : 'Non'}
                    onChange={handleHealthDualButtonChange('isHighLevelSport')}
                    multiSelect={false}
                  />
                </div>

                <div className={styles.field}>
                  <DualButton
                    label="Bénéficie de droits attachés à la RQTH"
                    option1="Oui"
                    option2="Non"
                    value={isRQTH ? 'Oui' : 'Non'}
                    onChange={handleHealthDualButtonChange('isRQTH')}
                    multiSelect={false}
                  />
                </div>

                <div className={styles.field}>
                  <DualButton
                    label="Extension BOE"
                    option1="Oui"
                    option2="Non"
                    value={isBOE ? 'Oui' : 'Non'}
                    onChange={handleHealthDualButtonChange('isBOE')}
                    multiSelect={false}
                  />
                </div>

                <div className={styles.field}>
                  <DualButton
                    label="Déclare bénéficier de la reconnaissance travailleur handicapé"
                    option1="Oui"
                    option2="Non"
                    value={isDisabled ? 'Oui' : 'Non'}
                    onChange={handleHealthDualButtonChange('isDisabled')}
                    multiSelect={false}
                  />
                </div>
              </div>

              <div className={styles.divider} />

              <div className={styles.section}>
                <h3 className={styles.sectionTitle}>
                  Études & Projet
                </h3>

                <div className={styles.formGrid}>
                  <div className={styles.field}>
                    <Dropdown
                      className={styles.dropdown}
                      label="Situation avant contrat"
                      name="situation_before_contract"
                      required
                      options={SITUATION_OPTIONS}
                      value={selectedSituationBeforeContract}
                      setValue={(option) => handleDropdownChange('situation_before_contract', option)}
                    />
                  </div>

                  <div className={styles.field}>
                    <Dropdown
                      className={styles.dropdown}
                      label="Dernière classe"
                      name="last_class"
                      required
                      options={CLASS_OPTIONS}
                      value={selectedLastClass}
                      setValue={(option) => handleDropdownChange('last_class', option)}
                    />
                  </div>

                  <div className={styles.field}>
                    <Dropdown
                      className={styles.dropdown}
                      label="Dernier diplôme préparé"
                      name="last_prepared_diploma"
                      required
                      options={DIPLOMA_OPTIONS}
                      value={selectedLastPreparedDiploma}
                      setValue={(option) => handleDropdownChange('last_prepared_diploma', option)}
                    />
                  </div>

                  <div className={styles.field}>
                    <Dropdown
                      className={styles.dropdown}
                      label="Diplôme ou titre le plus élevé obtenu"
                      name="highest_diploma_obtained"
                      required
                      options={HIGHEST_DIPLOMA_OPTIONS}
                      value={selectedHighestDiplomaObtained}
                      setValue={(option) => handleDropdownChange('highest_diploma_obtained', option)}
                    />
                  </div>

                  <TextInput
                    className={styles.field}
                    label="Intitulé précis du dernier diplôme ou titre obtenu"
                    name="highest_diploma_title"
                    type="text"
                    placeholder="Intitulé précis du diplôme"
                    value={student?.highest_diploma_title || ''}
                    onChange={handleStudentChange}
                  />

                  <div className={styles.field}>
                    <DualButton
                      label="Projet de création ou de reprise d'entreprise"
                      option1="Oui"
                      option2="Non"
                      name="businessOwnerProject"
                      value={businessOwnerProject}
                      onChange={handleBusinessOwnerProjectChange}
                      multiSelect={false}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.divider} />

              <h3 className={styles.sectionTitle}>
                Données personnelles
              </h3>


              <div className={styles.field} style={{ display: 'flex', alignItems: 'center', paddingBottom: '20px' }}>
                <span>J'accepte que mes informations soient transmises à des entreprises partenaires dans le cadre de la recherche d'une alternance ou d'un dossier d'apprentissage.</span>
                <Switch
                  name="consentToShareWithCompanies"
                  value={consentToShareWithCompanies}
                  onChange={() => handleSwitchChange('consentToShareWithCompanies', !consentToShareWithCompanies)}
                  className={styles.switch}
                />
              </div>


              <div className={styles.section} style={{ marginTop: '20px' }}>
                <h3 className={styles.sectionTitle}>
                  Règlement et conditions générales
                </h3>

                {settings.map((x, index) => (
                  <div className={styles.line} key={index}>
                    <div
                      className={styles.title}
                      onClick={() => {
                        if (x.id === 0) {
                          setVisibleCondition(true);
                        } else if (x.id === 1) {
                          setVisibleUseCondition(true);
                        } else if (x.id === 2) {
                          setVisibleReglement(true);
                        }
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      {x.title}
                    </div>
                    <Switch
                      className={styles.switch}
                      value={x.id === 0 ? acceptConditions : (x.id === 1 ? acceptUseConditions : acceptRules)}
                      onChange={() => handleChange(x.id)}
                    />
                  </div>
                ))}

                {/* Modales pour les conditions et le règlement */}
                <ModalConditionGeneral
                  visible={visibleCondition}
                  onClose={() => setVisibleCondition(false)}
                  title="Conditions générales"
                  figcaption="Veuillez lire attentivement les conditions générales avant d'accepter."
                />

                <ModalPolitiqueConfidentialite
                  visible={visibleUseCondition}
                  onClose={() => setVisibleUseCondition(false)}
                  title="Conditions d'utilisation"
                  figcaption="Veuillez lire attentivement les conditions d'utilisation avant d'accepter."
                />

                <ModalReglement
                  visible={visibleReglement}
                  onClose={() => setVisibleReglement(false)}
                  title="Règlement intérieur"
                  figcaption="Veuillez lire attentivement le règlement intérieur avant d'accepter."
                />

              </div>


              {acceptConditions && acceptUseConditions && acceptRules ? (
                <div className={styles.buttonContainer}>
                  <button
                    className={cn("button", styles.button)}
                    type="submit"
                    disabled={isSaving}
                  >
                    {isSaving ? "Sauvegarde en cours..." : "Sauvegarder"}
                  </button>
                </div>
              ) : (
                <div className={styles.buttonContainer} style={{ opacity: 0.7, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: isMobile ? 'column' : 'row' }}>
                  <div className={styles.infoText}>
                    Veuillez accepter les conditions générales, les conditions d'utilisation et le règlement intérieur pour continuer
                  </div>
                  <button
                    className={cn("button", styles.button)}
                    type="button"
                    disabled={true}
                    style={{ cursor: 'not-allowed', marginLeft: '15px' }}
                  >
                    Sauvegarder
                  </button>
                </div>
              )}
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default CompleteAccount;
